import { postUpdatePersonalDetails } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_UpdatePersonalDetailsThunk = createAsyncThunk(
  "reKyc_UpdatePersonalDetailsThunk",
  async ({ body, token }) => {
    try {
      const response = await postUpdatePersonalDetails(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
